import React from 'react';
import './view-archived-game.styles.scss';
import TemplateGamePreview from '../managing/template-game-preview.component';
import { useSelector } from 'react-redux';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';

const ViewArchivedGame = () => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const navigate = useNavigate();

    return (
        <div className={`view-archived-game ${screenSize}`}>
            <div className='g-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-0-5"></div>
                <TemplateGamePreview />
            </div>
        </div>
    )
}

export default ViewArchivedGame